// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1ser_","detailsBorder":"styles_detailsBorder__M33NX"};